import moment from 'moment';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

const _extendDateConstructor = (serverDate) => {
    // eslint-disable-next-line no-global-assign
    Date = class extends Date {
        constructor(...options) {
            if (options.length) {
                super(...options);
            } else {
                super(serverDate.year, serverDate.month, serverDate.day);
            }
        }
    };

    moment.now = () => {
        return new Date().getTime();
    };
};

const _syncAppWithServer = (additionalHeaders = {}) => {
    JsonRPCService.send(getProxiedServiceUrl('time'), 'getTimeTravelDate', [], additionalHeaders).then((response) => {
        const responseDate = response.localDate;
        const realDate = new Date();
        const newDate = new Date(responseDate.year, responseDate.month, responseDate.day);
        realDate.setHours(0,0,0,0);

        if (response && response.isTimeTravelEnv && newDate > realDate) {
            _extendDateConstructor(responseDate);
        }
    });
};

const _init = (...auth) => {
    _syncAppWithServer(...auth);
};

export default {
    init: _init,
};